import type { RootState } from '@/store/store'

export const selectUserInfo = (state: RootState) => state.ui

export const selectIsNavBarCollapsed = (state: RootState) => state.ui.collapsed

export const selectIsDarkMode = (state: RootState) => state.ui.isDarkMode
